import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Sidebar } from '../sidebar/sidebar';
import { Toolbar } from '../toolbar/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Profile, TokenSession } from '../../core/models/users.interface';
import { AuthService } from '../../core/services/auth/auth';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorageService } from '../../core/services/local-storage/local-storage';
import { ProfileService } from '../../core/services/profile/profile';
import { LayoutService } from '../../core/services/layout/layout';
import { DecodedToken } from '../../core/models/auth.interface';
import { jwtDecode } from 'jwt-decode';
import { catchError, switchMap } from 'rxjs';
import { Footer } from '../footer/footer';
import { CommonModule } from '@angular/common';
import { Loading } from '../../shared/components/loading/loading';
@Component({
  selector: 'app-body',
  imports: [
    CommonModule,
    RouterOutlet,
    RouterOutlet,
    MatSidenavModule,
    Toolbar,
    Footer,
    Sidebar,
    Loading,
  ],
  templateUrl: './body.html',
  styleUrl: './body.css',
})
export class Body {
  isSidebarOpen = false;
  isMobile = false;
  userSession: TokenSession | null = null;

  constructor(
    private authService: AuthService,
    private jwtHelper: JwtHelperService,
    private localStorage: LocalStorageService,
    private perfilService: ProfileService,
    private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 768;
    this.authService.restoreSession();
    const user = this.perfilService.getUserProfile();
    this.authService.token$.subscribe((token) => (this.userSession = token));
    this.localStorage.initStorage();

    const rawToken = localStorage.getItem('token');
    if (!rawToken) return; // ← sin token, no hacer nada

    const parseToken = JSON.parse(rawToken) as TokenSession;

    // ← pasar el access token explícitamente al helper
    const isExpired = this.jwtHelper.isTokenExpired(parseToken.access);

    if (isExpired) {
      this.authService
        .refreshToken(parseToken.refresh)
        .pipe(
          catchError(() => {
            this.rejectUser();
            return [];
          }),
          switchMap((response) => {
            const freshToken: TokenSession = {
              access: response.access,
              refresh: parseToken.refresh,
            };
            this.authService.setToken(freshToken);
            localStorage.setItem('token', JSON.stringify(freshToken));
            const decoded: DecodedToken = jwtDecode(response.access);
            return this.perfilService.getOneProfile(String(decoded.user_id));
          }),
        )
        .subscribe({
          next: (profile) => {
            this.setProfile(profile);
            this.layoutService.genMenuLinks(profile);
          },
          error: () => this.rejectUser(),
        });
    } else {
      const user = this.perfilService.getUserProfile();
      this.layoutService.genMenuLinks(user);
      const decoded: DecodedToken = jwtDecode(parseToken.access); // ← usar access, no el raw token
      this.perfilService.getOneProfile(String(decoded.user_id)).subscribe({
        next: (profile) => this.setProfile(profile),
        error: () => this.rejectUser(),
      });
    }
  }

  private rejectUser(): void {
    this.authService.logout();
  }

  setProfile(profile: Profile) {
    this.perfilService.setUserProfile(profile);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
}
